import { UseBaseMutationOptions } from '@/core/api/type'
import { useMutation } from '@tanstack/react-query'
import { DailyCheckInMutationKeys } from '../../../keys'
import {
	UpdateDailyCheckInRequest,
	UpdateDailyCheckInResponse,
} from '../../../type'
import { updateDailyCheckIn } from '../../services'

interface UpdateDailyCheckInParams {
	id: string
	payload: UpdateDailyCheckInRequest
}

export default function useMutationUpdateDailyCheckIn(
	props?: UseBaseMutationOptions<
		UpdateDailyCheckInResponse,
		UpdateDailyCheckInParams
	>,
) {
	return useMutation({
		mutationKey: [DailyCheckInMutationKeys.UpdateDailyCheckIn],
		mutationFn: (params: UpdateDailyCheckInParams) =>
			updateDailyCheckIn(params.id, params.payload),
		...props,
	})
}
